import {
  Bell,
  Briefcase,
  Contact2,
  FileText,
  Inbox,
  PenLine,
  ScrollText,
  ToggleRightIcon,
  Users,
  Workflow as WorkflowIcon,
} from 'lucide-react';
import { BiChart } from 'react-icons/bi';
import { FiBook, FiHome } from 'react-icons/fi';

import { JobIcon } from './entityIcons';
import { isWorkflowsEnabled } from './features';
import { ROUTES } from './routes';

export type MenuItem = {
  id: string;
  icon: React.ElementType;
  label: string;
  title: string;
  url: string;
  hidden?: boolean;
  disabled: boolean;
  exact?: boolean;
  // Shown only to tenant admins.
  adminOnly?: boolean;
  // Shown only when the tenant switch is on (Prompt Templates: `prompts/config`).
  requiresPrompts?: boolean;
};

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    icon: FiHome,
    label: 'Dashboard',
    title: 'Dashboard',
    url: ROUTES.DASHBOARD,
    disabled: false,
  },
  {
    id: 'jobs',
    icon: JobIcon,
    label: 'Jobs',
    title: 'Jobs Management',
    url: ROUTES.JOBS,
    disabled: false,
  },
  {
    id: 'knowledge',
    icon: FiBook,
    label: 'Knowledge base',
    title: 'Knowledge Base',
    url: ROUTES.KNOWLEDGE_BASE,
    disabled: false,
  },
  {
    id: 'prompts',
    icon: ScrollText,
    label: 'Prompts',
    title: 'Prompts',
    url: ROUTES.PROMPTS,
    disabled: false,
    exact: false,
    requiresPrompts: true,
  },
  {
    id: 'sales-performance',
    icon: BiChart,
    label: 'Sales performance',
    title: 'Sales Performance',
    url: '/sales',
    disabled: false,
  },
  {
    id: 'quote-documents',
    icon: FileText,
    label: 'Quote Documents',
    title: 'Quote Documents',
    url: ROUTES.QUOTE_DOCUMENTS,
    disabled: false,
    exact: false,
  },
  {
    id: 'contacts',
    icon: Contact2,
    label: 'Contacts',
    title: 'Contacts',
    url: ROUTES.CONTACTS,
    disabled: false,
    exact: false,
  },
  {
    id: 'cases',
    icon: Briefcase,
    label: 'Cases',
    title: 'Cases',
    url: ROUTES.CASES,
    disabled: false,
    exact: false,
  },
  {
    id: 'portal-jobs',
    icon: Inbox,
    label: 'Portal Jobs',
    title: 'Portal Jobs',
    url: ROUTES.PORTAL_JOBS,
    disabled: false,
    exact: false,
  },
  {
    id: 'teams',
    icon: Users,
    label: 'Teams',
    title: 'Teams',
    url: ROUTES.TEAMS,
    disabled: false,
    exact: false,
  },
  {
    id: 'notifications',
    icon: Bell,
    label: 'Notifications',
    title: 'Notifications',
    url: ROUTES.NOTIFICATIONS,
    disabled: false,
    exact: false,
  },
  {
    id: 'workflows',
    icon: WorkflowIcon,
    label: 'Workflows',
    title: 'Workflows',
    url: ROUTES.WORKFLOWS,
    disabled: !isWorkflowsEnabled,
    exact: false,
  },
];

export const nonMenuItems: MenuItem[] = [
  {
    id: 'profile',
    icon: null as any,
    label: 'Profile',
    title: 'Profile',
    url: ROUTES.PROFILE,
    disabled: false,
  },
  {
    id: 'search',
    icon: null as any,
    label: 'Advanced search',
    title: 'Advanced Search',
    url: ROUTES.SEARCH,
    disabled: false,
  },
];

export const bottomMenuItems: MenuItem[] = [
  {
    id: 'integrations',
    icon: ToggleRightIcon,
    label: 'Integrations',
    title: 'Integrations',
    url: ROUTES.INTEGRATIONS,
    disabled: false,
  },
  {
    id: 'worksheet-pass',
    icon: PenLine,
    label: 'Worksheet Pass',
    title: 'Worksheet Pass',
    url: ROUTES.WORKSHEET_PASS,
    disabled: false,
    exact: false,
    adminOnly: true,
  },
];
